module.exports = __webpack_public_path__ + "img/bg-score.6c4e0f31.png";